import {
  ListItemTile,
  TileStatus,
  TileType,
  VxlCardGroupTile,
} from '@varo/graphql-schema-types';
import { VXLComponentId } from 'shared/renderer/types';

const onboardingProgressChecklistTile = (
  tile: ListItemTile & VxlCardGroupTile,
) => {
  if (!tile || tile?.status !== TileStatus.Loaded) {
    return null;
  }

  return {
    id: tile.id,
    props: {
      title: tile.title,
      welcomeMessage: tile.subtitle,
      listItems: tile.tiles,
      progress: tile.progress,
      displayAnalytics: tile.displayAnalytics,
    },
    name: VXLComponentId.PROGRESS_CHECK_LIST,
  };
};

export const shouldHideBrazeForTile = (
  tile?: Partial<ListItemTile & VxlCardGroupTile> & { tileType?: TileType },
) => {
  return !!(
    tile &&
    tile.tileType === TileType.VxlCardGroupChecklistTile &&
    tile.status === TileStatus.Loaded
  );
};

export default onboardingProgressChecklistTile;
